import { useEffect } from 'react'
import { useContext } from 'react'
import { useState } from 'react'
import UserContext from '../Context/UserContext'
import { sendNewPasswordEmail } from '../Requests/firebaseAuth'

export default function ForgotPassword(){
  const [email, setEmail] = useState('')
  const {url} = useContext(UserContext)
  const [disabled, setDisabled] = useState(false)
  useEffect(()=>{
    document.body.className = document.body.className = 'bg-image'
  })
  const handleSubmit = async(e) => {
    e.preventDefault()
    await sendNewPasswordEmail(email, url)
    setDisabled(true)
  }
  
  return <div className="container mx-auto px-4">
      <div className="w-full sm:w-96 mx-auto sm:mx-0 mb-4">
      <img alt="Channel Talks logo" src={require('../Assets/channeltalks-white.png')}/>
      <img alt="Channel Talks logo" src={require('../Assets/slogan-white.png')}/>
      </div>
    <div className="bg-white rounded-[10px] py-4 px-3 w-1/2 max-w-[500px] mx-auto flex flex-col justify-center items-center">
      <h1 className="text-xl">Cambiar contraseña</h1>
      <form onSubmit={handleSubmit} className='flex flex-col gap-4 w-full my-4'>
        <div className="input-holder w-[75%]">
          <input type="email" name='email' id='change-password-email' value={email} onChange={(e)=>{setEmail(e.target.value)}} required/>
          <label htmlFor="change-password-email">Email</label>
        </div>
        {disabled?<span className='w-[75%] mx-auto text-center'>Se le ha enviado un correo para combiar su contraseña</span>:<></>}
        <button className="send-btn" disabled={disabled}>Aceptar</button>
      </form>
    </div>
  </div>
}